// extracted by css-extract-rspack-plugin
export default {"requiredAsterisk":"j7_ThK2WHf4f2C9m","outerSpan":"H0RMC4zzkISDZYd6"};